import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=5205f439&scoped=true&"
import script from "./Date.vue?vue&type=script&lang=ts&"
export * from "./Date.vue?vue&type=script&lang=ts&"
import style0 from "./Date.vue?vue&type=style&index=0&id=5205f439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5205f439",
  null
  
)

export default component.exports